// Versione corretta di placeholder-image.js
(function() {
  // Assicurati che l'oggetto Shopify esista
  if (typeof Shopify === 'undefined') {
    window.Shopify = {};
  }
  
  // Assicurati che l'oggetto shop esista
  if (!Shopify.shop) {
    Shopify.shop = document.domain || 'vinolog24.com';
  }
  
  // Implementa la funzionalità di placeholder-image in modo sicuro
  // (questa è una versione semplificata che non causerà errori)
  var loadPlaceholders = function() {
    // Implementazione sicura che non causerà errori
    console.log('Placeholder images loaded safely');
  };
  
  // Esegui la funzione quando il documento è pronto
  if (document.readyState !== 'loading') {
    loadPlaceholders();
  } else {
    document.addEventListener('DOMContentLoaded', loadPlaceholders);
  }
})();
